module.exports = __webpack_public_path__ + "img/country-9.970661ac.jpg";